import React, { createContext, useMemo, useState } from "react"

type AuthState = {
  isAuthenticated: boolean
  setIsAuthenticated: (value: boolean) => void
  businessId?: string | null
  setBusinessId: (value: string | null) => void
}

const emptyFn = (): void | Promise<void> => {
  console.warn(`StoreContext not ready!`)
}

export const INITIAL_VALUES: AuthState = {
  isAuthenticated: false,
  setIsAuthenticated: emptyFn,
  businessId: null,
  setBusinessId: emptyFn,
}

export const useAuthState = (): AuthState => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    INITIAL_VALUES.isAuthenticated
  )
  const [businessId, setBusinessId] = useState<string | null>(
    INITIAL_VALUES.businessId || null
  )

  return {
    isAuthenticated,
    businessId,
    setBusinessId,
    setIsAuthenticated,
  }
}

export const AuthContext = createContext(INITIAL_VALUES)

type StoreProviderProps = {
  children: React.ReactNode
}

const AuthProvider = ({ children }: StoreProviderProps) => {
  const { ...authState } = useAuthState()

  const values = useMemo(
    () => ({
      ...authState,
    }),
    [authState]
  )

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>
}

export default AuthProvider
